module.exports = __webpack_public_path__ + "img/484-6f4bbc.png";